var asAnswers={};
var asTimer=null;
var SCRIPT_URL='https://script.google.com/macros/s/AKfycbwEzI-8hilSXnCrbIp8XvvE7dfsFpeprtf-3F6N_Ok7enw0LxpwV5tQIxKI6OPJFgHU6A/exec';

function asUpdateProgress(q){
  var total=9,pct=q>total?100:Math.round(((q-1)/total)*100);
  document.getElementById('as-prog').style.width=pct+'%';
  document.getElementById('as-qlabel').textContent=q<=total?'Question '+q+' of '+total:'Almost done!';
  document.getElementById('as-qpct').textContent=pct+'%';
}

function asGoTo(from,to){
  if(from===4) asAnswers.q4=document.getElementById('asq4val').value;
  if(from===7) asAnswers.q7=document.getElementById('asq7val').value;
  if(from===9) asAnswers.q9=document.getElementById('asq9val').value;
  document.getElementById('asq'+from).classList.remove('active');
  document.getElementById('asq'+to).classList.add('active');
  asUpdateProgress(to);
  window.scrollTo(0,0);
}

function asSchedule(from,to){
  if(asTimer) clearTimeout(asTimer);
  asTimer=setTimeout(function(){ asGoTo(from,to); },1800);
}

function asSetupMC(gridId,qNum,nextQ){
  document.querySelectorAll('#'+gridId+' .as-mc-opt').forEach(function(opt){
    opt.addEventListener('click',function(){
      if(opt.classList.contains('correct')||opt.classList.contains('incorrect')||opt.classList.contains('selected')) return;
      var opts=document.querySelectorAll('#'+gridId+' .as-mc-opt');
      var isCorrect=opt.getAttribute('data-correct');
      asAnswers['q'+qNum]=opt.getAttribute('data-val');
      if(isCorrect==='true'){
        opts.forEach(function(o){ if(o!==opt) o.classList.add('incorrect'); });
        opt.classList.add('correct');
      } else if(isCorrect==='false'){
        opts.forEach(function(o){
          if(o.getAttribute('data-correct')==='true') o.classList.add('correct');
          else if(o!==opt) o.classList.add('incorrect');
        });
        opt.classList.add('incorrect');
      } else {
        opts.forEach(function(o){ o.classList.remove('selected'); });
        opt.classList.add('selected');
      }
      asSchedule(qNum,nextQ);
    });
  });
}

function asSelectPrint(card,qNum){
  if(asTimer) clearTimeout(asTimer);
  document.querySelectorAll('#asq3opts .as-print-card').forEach(function(c){ c.classList.remove('selected'); });
  card.classList.add('selected');
  asAnswers['q'+qNum]=card.getAttribute('data-val');
  asSchedule(qNum,qNum+1);
}

function asEnableText(inputId,btnId,qNum){
  var el=document.getElementById(inputId),btn=document.getElementById(btnId);
  el.addEventListener('input',function(){
    btn.disabled=el.value.trim().length===0;
    asAnswers['q'+qNum]=el.value;
  });
}

function asCheckSubmit(){
  var f=document.getElementById('as-first').value.trim();
  var l=document.getElementById('as-last').value.trim();
  var e=document.getElementById('as-email').value.trim();
  document.getElementById('as-submit').disabled=!(f&&l&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e));
}

function asSubmitQuiz(){
  var btn=document.getElementById('as-submit');
  btn.disabled=true;
  btn.textContent='Submitting...';
  var payload={
    firstName:document.getElementById('as-first').value.trim(),
    lastName:document.getElementById('as-last').value.trim(),
    email:document.getElementById('as-email').value.trim(),
    q1:asAnswers.q1||'',
    q2:asAnswers.q2||'',
    q3:asAnswers.q3||'',
    q4:asAnswers.q4||'',
    q5:asAnswers.q5||'',
    q6:asAnswers.q6||'',
    q7:asAnswers.q7||'',
    q8:asAnswers.q8||'',
    q9:asAnswers.q9||''
  };
  fetch(SCRIPT_URL,{method:'POST',body:JSON.stringify(payload)})
    .catch(function(){})
    .finally(function(){
      document.getElementById('asq10').classList.remove('active');
      document.getElementById('as-success').style.display='block';
      document.getElementById('as-prog').style.width='100%';
      document.getElementById('as-qlabel').textContent='Complete!';
      document.getElementById('as-qpct').textContent='100%';
    });
}

window.addEventListener('load',function(){
  document.querySelectorAll('#asq3opts .as-print-card').forEach(function(card){
    card.addEventListener('click',function(){ asSelectPrint(card,3); });
  });
  document.getElementById('as-first').addEventListener('input',asCheckSubmit);
  document.getElementById('as-last').addEventListener('input',asCheckSubmit);
  document.getElementById('as-email').addEventListener('input',asCheckSubmit);
  asSetupMC('asq1opts',1,2);
  asSetupMC('asq2opts',2,3);
  asSetupMC('asq5opts',5,6);
  asSetupMC('asq6opts',6,7);
  asSetupMC('asq8opts',8,9);
  asEnableText('asq4val','asbtn4',4);
  asEnableText('asq7val','asbtn7',7);
  asEnableText('asq9val','asbtn9',9);
  document.getElementById('asbtn4').addEventListener('click',function(){ asGoTo(4,5); });
document.getElementById('asbtn7').addEventListener('click',function(){ asGoTo(7,8); });
document.getElementById('asbtn9').addEventListener('click',function(){ asGoTo(9,10); });
  document.getElementById('as-submit').addEventListener('click',function(){ asSubmitQuiz(); });
  asUpdateProgress(1);
});
